import { useEffect, useState } from "react";

function BottomSheet({ open, onClose, children, maxWidth = "500px" }) {
  const [shouldRender, setShouldRender] = useState(open);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setIsClosing(false);
    }
  }, [open]);

  const closeSheet = () => {
    setIsClosing(true);

    setTimeout(() => {
      setShouldRender(false);
      setIsClosing(false);
      onClose();
    }, 220);
  };

  if (!shouldRender) return null;

  return (
    <div
      style={{
        ...overlayStyle,
        animation: isClosing
          ? "bottomSheetFadeOut 0.22s ease forwards"
          : "bottomSheetFadeIn 0.22s ease forwards",
      }}
      onClick={closeSheet}
    >
      <div
        style={{
          ...sheetStyle,
          maxWidth,
          animation: isClosing
            ? "bottomSheetSlideDown 0.22s ease forwards"
            : "bottomSheetSlideUp 0.28s cubic-bezier(0.22, 1, 0.36, 1) forwards",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={handleStyle} />
        {children}
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.55)",
  zIndex: 10000,
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
};

const sheetStyle = {
  width: "100%",
  backgroundColor: "#111",
  borderTopLeftRadius: "24px",
  borderTopRightRadius: "24px",
  border: "1px solid rgba(255,255,255,0.08)",
  padding: "12px 20px calc(110px + env(safe-area-inset-bottom))",
  boxShadow: "0 -18px 40px rgba(0,0,0,0.55)",
};

const handleStyle = {
  width: "44px",
  height: "5px",
  borderRadius: "999px",
  backgroundColor: "#444",
  margin: "0 auto 16px",
};

const animationStyles = document.createElement("style");
animationStyles.innerHTML = `
  @keyframes bottomSheetFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes bottomSheetFadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
  }

  @keyframes bottomSheetSlideUp {
    from { transform: translateY(100%); }
    to { transform: translateY(0); }
  }

  @keyframes bottomSheetSlideDown {
    from { transform: translateY(0); }
    to { transform: translateY(100%); }
  }
`;

if (!document.head.querySelector("[data-bottom-sheet-animations]")) {
  animationStyles.setAttribute("data-bottom-sheet-animations", "true");
  document.head.appendChild(animationStyles);
}

export default BottomSheet;